import { Button, Input, Radio,} from 'antd';
import {  ToastSuccess } from 'components/Toaster';
import { ComponentArrasteSolteService } from 'core/http/service/componetInteraction/ComponentArrasteSolte.service';

import Colors from 'enums/Colors';
import ComponentArrasteSolte from 'models/componentInteraction/ComponentArrasteSolte';
import ComponentArrasteSolteQuestion from 'models/componentInteraction/ComponentArrasteSolteQuestion';
import ComponentArrasteSolteQuestionAlternativa from 'models/componentInteraction/ComponentArrasteSolteQuestionAlternativa';

import React, { useEffect, useState } from 'react';

import { MdDeleteForever, MdKeyboardArrowLeft, MdKeyboardArrowRight, MdSaveAs } from 'react-icons/md';
import styled from 'styled-components';

const Styled = {
    Container: styled.div`
        display: flex;
        flex-direction: column;
        max-width: 1280px;
        gap: 1rem;
    `,

    Row: styled.div`
        display: flex;
    `,

    RowEnd: styled.div`
        display: flex;
        align-items: center;
        justify-content: end;
        width: 100%;
        gap: 1rem;
    `,

    RowBetween: styled.div`
        display: flex;
        align-items: center;
        justify-content: space-between;
    `,

    Title: styled.h1`
        font-family: 'Barlow';
        font-size: 18px;
        font-weight: 600;
        line-height: 25.2px;
        text-align: left;
        text-decoration-skip-ink: none;
        color: ${Colors.Blue};
    `,

    SubTitle: styled.h2`
        font-family: 'Barlow';
        font-size: 14px;
        font-weight: 600;
        line-height: 19.6px;
        text-align: left;
        text-decoration-skip-ink: none;
    `,

    Preview: styled.div<{ isPreview: boolean }>`
        border: 1px solid ${Colors.Blue};
        width: 60px;
        height: 40px;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 10px;
        background-color: ${({ isPreview }) => (isPreview ? Colors.Blue : Colors.White)};
        cursor: pointer;
    `,

    Column: styled.div`
        display: flex;
        width: 100%;
        gap: 0.5rem;
        flex-direction: column;
    `,

    Regua: {
        Container: styled.div``,
    },

    Options: {
        Container: styled.div`
            display: flex;
            align-items: center;
            gap: 1rem;
            height: 52px;
        `,

        NumberPosition: styled.div`
            width: 50px;
            height: 50px;
            padding: 15px 21px 15px 21px;
            gap: 16px;
            border-radius: 5px;
            border: 1px 0px 0px 0px;
            opacity: 0px;
            border: 1px solid #e6e6e6;
            background: #f9f9f9;
        `,
    },

    Navigation: {
        Arrow: styled.div`
            display: flex;
            align-items: center;
            justify-content: center;
            margin-left: 10px;
            margin-right: 10px;
            width: 62px;
            border-radius: 5px;
            border: 1px solid #e6e6e6;
            cursor: pointer;
            transition: all 0.3s;

            &:hover {
                border: 1px solid ${Colors.Blue};
            }
        `,

        ItemFooter: styled.div<{ isActive: boolean }>`
            display: flex;
            align-items: center;
            justify-content: center;
            width: 32px;
            height: 32px;
            border-radius: 4px;
            align-items: center;
            justify-content: center;
            border: 1px solid ${Colors.Blue};
            color: ${({ isActive }) => (isActive ? Colors.White : Colors.Blue)};
            background-color: ${({ isActive }) => (isActive ? Colors.Blue : Colors.White)};
            cursor: pointer;
        `,
    },

    Feedback: {
        Container: styled.div`
            display: flex;
            gap: 1rem;
            height: 133px;
            width: 100%;
        `,
    },

    Button: styled.button`
        width: 38px;
        height: 38px;
        border-radius: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        border: 1px solid ${Colors.Grey11};
        margin-left: 10px;
    `,
};

interface IComponentArrasteSolteAdmin {
    dados: ComponentArrasteSolte | null;
    codigoInteraction: number;
}

const ComponentArrasteSolteAdmin = ({ dados, codigoInteraction }: IComponentArrasteSolteAdmin) => {
    const [arrasteSolte, setArrasteSolte] = useState<ComponentArrasteSolte | null>(dados);
    const [indexQuestion, setIndexQuestion] = useState<number>(0);
    const [quantityQuestions, setQuantityQuestions] = useState<number>(1);

    //loadings
    const [loadingSave, setLoadingSave] = useState<boolean>(false);

    //services
    const service = new ComponentArrasteSolteService();

    const nextRegua = () => {
        if (quantityQuestions > 1 && indexQuestion + 1 < quantityQuestions) {
            setIndexQuestion(indexQuestion + 1);
            return;
        }
    };

    const reviver = () => {
        if (indexQuestion > 0) {
            setIndexQuestion(indexQuestion - 1);
        }
    };

    const handleSave = async () => {
        if (arrasteSolte) {
            setLoadingSave(true);

            if (arrasteSolte.codigo === -1) {
                const { data, status } = await service.saveComponent(codigoInteraction, arrasteSolte);
                if (status === 201) {
                    ToastSuccess('Componente salvo com sucesso!');
                    setArrasteSolte(data);
                }
            } else {
                const { data, status } = await service.updateComponent(codigoInteraction, arrasteSolte);
                if (status === 200) {
                    ToastSuccess('Componente atualizado com sucesso!');
                    setArrasteSolte(data);
                }
            }

            setLoadingSave(false);
        }
    };

    const handleNewAlternativa = (index: number) => {
        const novaAlternativa = new ComponentArrasteSolteQuestionAlternativa().fromJSON({
            codigo: -1,
            text: '',
            correct: false,
            ordem: dados?.questions[indexQuestion]?.alternativas?.length ?? 0 + 1,
        });

        if (arrasteSolte && arrasteSolte.questions) {
            const questions = arrasteSolte.questions.map((q: ComponentArrasteSolteQuestion, i: number) => {
                if (index === i) {
                    // Retorna um novo objeto quiz com as alternativas atualizadas
                    return new ComponentArrasteSolteQuestion().fromJSON({
                        codigo: q.codigo,
                        text: q.text,
                        feedback: q.feedback,
                        alternativas: [...q.alternativas, novaAlternativa], // Adiciona a nova alternativa
                    });
                }
                return q; // Retorna o quiz original se não for o que deve ser atualizado
            });

            // Atualiza o estado com a nova lista de quizzes
            setArrasteSolte((prev: any) => ({
                ...prev,
                questions: questions, // Atualiza a propriedade quizzes
            }));
        }
    };
    const handleNewQuestion = () => {
        const novaQuestion = new ComponentArrasteSolteQuestion().fromJSON({
            codigo: -1,
            text: '',
            feedback: '',
            alternativas: [
                new ComponentArrasteSolteQuestionAlternativa().fromJSON({
                    codigo: -1,
                    text: '',
                    correct: false,
                    ordem: 1,
                }),
                new ComponentArrasteSolteQuestionAlternativa().fromJSON({
                    codigo: -1,
                    text: '',
                    correct: true,
                    ordem: 2,
                }),
            ] as ComponentArrasteSolteQuestionAlternativa[],
        });
        if (arrasteSolte && arrasteSolte.questions) {
            const questions = [...arrasteSolte.questions, novaQuestion];

            setArrasteSolte((prev: any) => ({
                ...prev,
                questions: questions, // Atualiza a propriedade quizzes
            }));
            setQuantityQuestions(quantityQuestions + 1);
            setIndexQuestion(quantityQuestions);
        }
    };

    const removeAlternativa = async (index: number, indexAlt: number) => {
        const alternativaIndex = indexAlt; // índice da alternativa que você deseja remover

        let idAlternativaRemove = -1;

        // Verifica se arraste e questions existem
        if (arrasteSolte && arrasteSolte.questions) {
            const questionsAtualizados = arrasteSolte.questions.map((q: ComponentArrasteSolteQuestion, i: number) => {
                if (indexQuestion === i) {
                    idAlternativaRemove = q.alternativas[indexAlt].codigo;

                    // Retorna um novo objeto quiz com as alternativas atualizadas
                    const alternativasAtualizadas = q.alternativas.filter((_, altIndex: number) => altIndex !== alternativaIndex);
                    return new ComponentArrasteSolteQuestion().fromJSON({
                        codigo: q.codigo,
                        text: q.text,
                        feedback: q.feedback,
                        alternativas: alternativasAtualizadas,
                    });
                }
                return q; // Retorna o quiz original se não for o que deve ser atualizado
            });

            if (idAlternativaRemove != -1) {
                await service.deleteAlternativa(idAlternativaRemove);
            }

            setArrasteSolte((prev: any) => ({
                ...prev,
                questions: questionsAtualizados, // Atualiza a propriedade das questions
            }));
        }
    };

    const handleTextQuizze = (index: number, value: string) => {
        if (arrasteSolte && arrasteSolte.questions) {
            const questionsAtualizados = arrasteSolte.questions.map((q: ComponentArrasteSolteQuestion, i: number) => {
                if (index === i) {
                    // Retorna um novo objeto quiz com as alternativas atualizadas
                    return new ComponentArrasteSolteQuestion().fromJSON({
                        codigo: q.codigo,
                        text: value,
                        feedback: q.feedback,
                        alternativas: q.alternativas,
                    });
                }
                return q; // Retorna o quiz original se não for o que deve ser atualizado
            });
            // Atualiza o estado com a nova lista de quizzes
            setArrasteSolte((prev: any) => ({
                ...prev,
                questions: questionsAtualizados, // Atualiza a propriedade quizzes
            }));
        }
    };

    const removeQuestion = async () => {
        if (arrasteSolte && arrasteSolte.questions) {
            const idQuestion = arrasteSolte.questions[indexQuestion].codigo;

            if (idQuestion && idQuestion !== -1) {
                const { status } = await service.deleteQuestion(idQuestion);
                if (status === 204) {
                    ToastSuccess('Questão removida com sucesso!');
                }
            }
            // Filtra a lista de quizzes para remover o quiz no indexArraste
            const listAtt = arrasteSolte.questions.filter((_, i) => indexQuestion !== i);
            // Atualiza o índice, se necessário
            const newIndexQuiz = indexQuestion > 0 ? indexQuestion - 1 : 0; // Garante que não vá para um índice negativo
            setIndexQuestion(newIndexQuiz);
            setQuantityQuestions(quantityQuestions - 1);
            // Atualiza o estado com a nova lista de quizzes
            setArrasteSolte((prev: any) => ({
                ...prev,
                questions: listAtt,
            }));
        }
    };

    const atualizationAlternativa = (indexArraste: number, indexAlt: number, correct: boolean, value: string) => {
        if (arrasteSolte && arrasteSolte.questions) {
            const questionsAtualizados = arrasteSolte.questions.map((q: ComponentArrasteSolteQuestion, i: number) => {
                if (indexArraste === i) {
                    // Acessa a alternativa diretamente
                    const alternativa = q.alternativas[indexAlt];

                    // Cria uma nova alternativa com os valores atualizados
                    const alternativaAtualizada = new ComponentArrasteSolteQuestionAlternativa().fromJSON({
                        codigo: alternativa.codigo,
                        text: value,
                        correct: correct,
                        ordem: alternativa.ordem,
                    });
                    // Retorna um novo objeto quiz com a alternativa atualizada
                    return new ComponentArrasteSolteQuestion().fromJSON({
                        codigo: q.codigo,
                        text: q.text,
                        feedback: q.feedback,
                        alternativas: q.alternativas.map((a: ComponentArrasteSolteQuestionAlternativa, altIndex: number) =>
                            altIndex === indexAlt
                                ? alternativaAtualizada
                                : ({
                                      ...a,
                                      correct: correct ? false : q.alternativas[altIndex].correct,
                                  } as ComponentArrasteSolteQuestionAlternativa)
                        ),
                    });
                }
                return q; // Retorna o quiz original se não for o que deve ser atualizado
            });
            // Atualiza o estado com a nova lista de quizzes
            setArrasteSolte((prev: any) => ({
                ...prev,
                questions: questionsAtualizados, // Atualiza a propriedade quizzes
            }));
        }
    };

    useEffect(() => {
        if (dados === null || (Array.isArray(dados?.questions) && dados?.questions.length === 0)) {
            let global = new ComponentArrasteSolte().fromJSON({
                codigo: -1,
                title: 'Arraste e solte Testando',
                questions: [
                    new ComponentArrasteSolteQuestion().fromJSON({
                        codigo: -1,
                        text: 'Questão arrastável',
                        feedback: 'Feedback',
                        alternativas: [
                            new ComponentArrasteSolteQuestionAlternativa().fromJSON({
                                codigo: -1,
                                text: 'Verdadeiro',
                                correct: true,
                                ordem: 1,
                            }),
                            new ComponentArrasteSolteQuestionAlternativa().fromJSON({
                                codigo: -1,
                                text: 'Falso',
                                correct: false,
                                ordem: 2,
                            }),
                        ] as ComponentArrasteSolteQuestionAlternativa[],
                    }),
                ] as ComponentArrasteSolteQuestion[],
            });
            setArrasteSolte(global);
            setIndexQuestion(0);
        } else {
            if (dados) {
                setIndexQuestion(0);
                setQuantityQuestions(dados.questions.length);
                setArrasteSolte(dados);
            }
        }
    }, [dados]);

    return (
        <Styled.Container>
            <Styled.Column>
                <Styled.Title>Arraste e solta</Styled.Title>
                <Input
                    size="large"
                    placeholder="Digite o título"
                    showCount
                    maxLength={200}
                    onChange={e => setArrasteSolte((prev: any) => ComponentArrasteSolte.fromJSON({ ...prev, title: e.target.value }))}
                    value={arrasteSolte?.title}
                />
            </Styled.Column>
            {arrasteSolte?.questions.map((q: ComponentArrasteSolteQuestion, index: number) => {
                if (index === indexQuestion) {
                    const reviverButton: boolean = index > 0;
                    const nextButton: boolean = quantityQuestions > 1;
                    return (
                        <>
                            <strong>Questão {index + 1}</strong>
                            <Input
                                size="large"
                                placeholder="Digite o título"
                                showCount
                                maxLength={200}
                                value={q.text}
                                onChange={e => handleTextQuizze(index, e.target.value)}
                            />

                            <Styled.Row>
                                {reviverButton && (
                                    <Styled.Navigation.Arrow onClick={reviver}>
                                        <MdKeyboardArrowLeft size={22} />
                                    </Styled.Navigation.Arrow>
                                )}
                                <Styled.Column>
                                    <Styled.Title>Alternativas</Styled.Title>
                                    {q.alternativas.map((a: ComponentArrasteSolteQuestionAlternativa, indexAlt: number) => (
                                        <Styled.Row style={{ gap: '0.5rem' }} key={indexAlt}>
                                            <Radio
                                                name={`question-${indexQuestion}`}
                                                style={{ margin: '6px 0px' }}
                                                checked={a.correct}
                                                onChange={e => atualizationAlternativa(indexQuestion, indexAlt, e.target.checked, a.text)}
                                            />

                                            <Input
                                                size="large"
                                                placeholder="Texto da alternativa"
                                                showCount
                                                maxLength={200}
                                                value={a.text}
                                                onChange={e => atualizationAlternativa(indexQuestion, indexAlt, a.correct, e.target.value)}
                                            />

                                            {q.alternativas.length > 1 && (
                                                <Styled.Button onClick={() => removeAlternativa(indexQuestion, indexAlt)}>
                                                    <MdDeleteForever size={32} color={Colors.DeleteRed} />
                                                </Styled.Button>
                                            )}
                                        </Styled.Row>
                                    ))}
                                </Styled.Column>
                                {nextButton && (
                                    <Styled.Navigation.Arrow onClick={nextRegua}>
                                        <MdKeyboardArrowRight size={22} />
                                    </Styled.Navigation.Arrow>
                                )}
                            </Styled.Row>
                            <Styled.RowBetween>
                                <Styled.Column style={{ width: 'auto' }}>
                                    <Styled.SubTitle>Adicionar mais uma alternativa</Styled.SubTitle>
                                    <Button size="large" style={{ width: 200 }} onClick={() => handleNewAlternativa(indexQuestion)}>
                                        Adicionar + 1
                                    </Button>
                                </Styled.Column>

                                <>
                                    <Styled.Column style={{ width: 'auto' }}>
                                        <Styled.SubTitle>Salvar questão</Styled.SubTitle>
                                        <Button loading={loadingSave} size="large" style={{ width: 200 }} onClick={handleSave}>
                                            <MdSaveAs /> Salvar
                                        </Button>
                                    </Styled.Column>
                                    {indexQuestion != 0 && (
                                        <Styled.Column style={{ width: 'auto' }}>
                                            <Styled.SubTitle>Remover questão</Styled.SubTitle>
                                            <Button size="large" style={{ width: 200, color: Colors.DeleteRed }} onClick={removeQuestion}>
                                                <MdDeleteForever /> Remover
                                            </Button>
                                        </Styled.Column>
                                    )}
                                </>

                                <Styled.Column style={{ width: 'auto' }}>
                                    <Styled.SubTitle>Adicionar mais uma questão</Styled.SubTitle>
                                    <Button size="large" style={{ width: 200 }} onClick={() => handleNewQuestion()}>
                                        Adicionar + 1
                                    </Button>
                                </Styled.Column>
                            </Styled.RowBetween>
                        </>
                    );
                }
            })}

            <Styled.RowEnd>
                <p>Navegue entre as questões:</p>
                {Array.from({ length: quantityQuestions }).map((_, index) => (
                    <Styled.Navigation.ItemFooter onClick={() => setIndexQuestion(index)} isActive={indexQuestion == index} key={index}>
                        {index + 1}
                    </Styled.Navigation.ItemFooter>
                ))}
            </Styled.RowEnd>
        </Styled.Container>
    );
};

export default ComponentArrasteSolteAdmin;
